import React from 'react'

const About = () => {
    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>About Us</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="inner-about-us-sec">
                    <div className="container">
                        <div className="row" style={{ alignItems: 'center' }}>
                            <div className="col-lg-3 col-md-3 col-12">
                                <div className="inner-about-us-boxs wow fadeInLeft" data-wow-duration="2s">
                                    <img src="images/inner-about-us-1.jpg" alt="img" />
                                    <h2>Consec Adipisicing Elit</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi lobortis metus et nulla efficitur cursus.Nulla facilisi. Vestibulum et tincidunt arcu.</p>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-9 col-12">
                                <div className="inner-about-us-text wow fadeInRight" data-wow-duration="2s">
                                    <label>About</label>
                                    <h2>Igorilla.co</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi lobortis metus et nulla efficitur cursus. Nulla facilisi. Vestibulum et tincidunt arcu. Nam sodales elementum elementum. Mauris molestie elit at dui consequat iaculis. </p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi lobortis metus et nulla efficitur cursus. Nulla facilisi. Vestibulum et tincidunt arcu. Nam sodales elementum elementum. Mauris molestie elit at dui consequat iaculis. </p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi lobortis metus et nulla efficitur cursus. Nulla facilisi. Vestibulum et tincidunt arcu. Nam sodales elementum elementum. Mauris molestie elit at dui consequat iaculis. </p>
                                    <img src="images/inner-about-us-text-img.jpg" alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="inner-about-us-bottom-row">
                            <div className="row" style={{ alignItems: 'center' }}>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="inner-about-us-bottom-images wow fadeInUp" data-wow-duration="2s">
                                        <img src="images/inner-about-us-bottom-img.jpg" alt="img" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="inner-about-us-bottom-text  wow fadeInDown" data-wow-duration="2s">
                                        <h2>Consec <span>Adipisicing Elit</span></h2>
                                        <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
                                        <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default About